export const LIVE_POLL_INTERVAL_MILLISECONDS = 15000;
export const LIVE_AGENTS_TABLE_PREFIX = "LiveAgentsTable";
